// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calendar:not(.Common) {
  font-size: 0.92rem;
  padding: 0.7rem 0.7rem 0 0.7rem;
  background: white;
  border: 1px solid var(--bs-primary);
  border-radius: var(--bs-border-radius);
  outline: none;
}
.Calendar:not(.Common).is-valid {
  border-color: var(--bs-success);
}
.Calendar:not(.Common).is-invalid {
  border-color: var(--bs-danger);
}
.Calendar:not(.Common).is-dirty {
  border-color: var(--bs-warning);
}
.Calendar:not(.Common) div {
  user-select: none;
}
.Calendar:not(.Common) .Calendar-Header {
  padding: 0.2rem 1rem;
}
.Calendar:not(.Common) .Calendar-Header div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Calendar:not(.Common) .Calendar-Header div,
.Calendar:not(.Common) .Calendar-Header div input,
.Calendar:not(.Common) .Calendar-Header .sv-chevron-left,
.Calendar:not(.Common) .Calendar-Header .sv-chevron-right {
  color: var(--bs-primary);
}
.Calendar:not(.Common) .Calendar-Header .sv-chevron-left,
.Calendar:not(.Common) .Calendar-Header .sv-chevron-right {
  cursor: pointer;
}
.Calendar:not(.Common) .Calendar-Body {
  padding: 0.5rem 0rem;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date {
  margin: 0 0.5rem 0.5rem 0.5rem;
  cursor: pointer;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date > .row {
  color: var(--bs-gray-500);
  align-items: center;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date .row {
  height: 2rem;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date .day {
  margin-top: 0.2rem;
  height: 1.7rem;
  width: 1.7rem;
  border-radius: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--bs-primary);
  line-height: 1rem;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date .before {
  color: #d8d1ca;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date .today {
  border: 1px solid rgba(0, 0, 0, 0.236);
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date .selected {
  background: var(--bs-primary);
  color: #fff;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date .range-start {
  background: green;
  color: white;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date .range-end {
  background: green;
  color: white;
}
.Calendar:not(.Common) .Calendar-Body .Calendar-Date .range {
  background: rgba(0, 0, 0, 0.407);
  color: white;
}

.popover .Calendar:not(.Common) {
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
}
.popover .Calendar:not(.Common) .Calendar-Body {
  padding-bottom: 0;
}

.Calendar-New {
  position: relative;
  display: flex;
  padding: 0.5rem 1rem 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  line-height: 2rem;
  background-color: #fff;
  border-radius: var(--bs-border-radius);
  border: var(--bs-border-width) solid var(--bs-border-color);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  outline: none;
  user-select: none !important;
}
.Calendar-New:focus, .Calendar-New:focus-within {
  box-shadow: 0 0 0 0.25rem rgba(27, 62, 111, 0.15);
}
.Calendar-New > * {
  width: 100%;
}
.Calendar-New.is-valid {
  border-color: var(--bs-success);
}
.Calendar-New.is-invalid {
  border-color: var(--bs-danger);
}
.Calendar-New.is-dirty {
  border-color: var(--bs-warning);
}
.Calendar-New .Calendar-Header {
  display: flex;
  width: 100%;
  padding: 0;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}
.Calendar-New .Calendar-Header .Calendar-Month {
  padding: 0rem 0.5rem;
  font-size: 0.875rem;
}
.Calendar-New .Calendar-Header .Calendar-Year .Input {
  width: 4rem;
  text-align: center;
  padding: 0.15rem;
  border-color: var(--bs-border-color) !important;
}
.Calendar-New .Calendar-Header .Calendar-Controls {
  display: flex;
  flex-grow: 1;
  justify-content: end;
  align-items: center;
  gap: 1rem;
}
.Calendar-New .Calendar-Body {
  display: flex;
  flex-direction: column;
}
.Calendar-New .Calendar-Body .Calendar-Week {
  display: flex;
  justify-content: space-between;
}
.Calendar-New .Calendar-Body .Calendar-Week:first-of-type .Calendar-Day .Calendar-Date {
  color: rgba(0, 0, 0, 0.25);
}
.Calendar-New .Calendar-Body .Calendar-Week .Calendar-Day {
  position: relative;
  margin: 0;
  text-align: center;
}
.Calendar-New .Calendar-Body .Calendar-Week .Calendar-Day > .Calendar-Date {
  position: relative;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  margin: 0.15rem;
  padding: 0.15rem 0.25rem;
  z-index: 1;
  text-transform: uppercase;
}
.Calendar-New .Calendar-Body .Calendar-Week .Calendar-Day.Calendar-Outset > .Calendar-Date {
  color: rgba(0, 0, 0, 0.25);
}
.Calendar-New .Calendar-Body .Calendar-Week .Calendar-Day.Calendar-Range > .Calendar-Date {
  background: var(--bs-gray-300);
}
.Calendar-New .Calendar-Body .Calendar-Week .Calendar-Day:not(.Calendar-Selected).Calendar-Today > .Calendar-Date {
  border: var(--bs-border-width) solid var(--bs-gray-500) !important;
}
.Calendar-New .Calendar-Body .Calendar-Week .Calendar-Day.Calendar-Selected > .Calendar-Date {
  background: var(--bs-primary);
  border-color: var(--bs-primary);
  color: var(--bs-white);
}
.Calendar-New .Calendar-Body .Calendar-Week .Calendar-Day.Calendar-Range + .Calendar-Range:before {
  content: "";
  position: absolute;
  width: 100%;
  height: calc(100% - 0.3rem);
  top: 0.15rem;
  left: -50%;
  background-color: var(--bs-gray-300);
  z-index: 0;
}

.popover-body > .Calendar-New {
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.popover-body > .Calendar-New .Calendar-Body {
  padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Calendar/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,+BAAA;EACA,iBAAA;EACA,mCAAA;EACA,sCAAA;EACA,aAAA;AACF;AACE;EACE,+BAAA;AACJ;AAEE;EACE,8BAAA;AAAJ;AAGE;EACE,+BAAA;AADJ;AAIE;EACE,iBAAA;AAFJ;AAKE;EACE,oBAAA;AAHJ;AAKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAHN;AAMI;;;;EAIE,wBAAA;AAJN;AAOI;;EAEE,eAAA;AALN;AAQE;EACE,oBAAA;AANJ;AAQI;EACE,8BAAA;EACA,eAAA;AANN;AAQM;EACE,yBAAA;EACA,mBAAA;AANR;AASM;EACE,YAAA;AAPR;AAUM;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,iBAAA;AARR;AAUM;EACE,cAAA;AARR;AAUM;EACE,sCAAA;AARR;AAUM;EACE,6BAAA;EACA,WAAA;AARR;AAUM;EACE,iBAAA;EACA,YAAA;AARR;AAUM;EACE,iBAAA;EACA,YAAA;AARR;AAUM;EACE,gCAAA;EACA,YAAA;AARR;;AAaA;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAVF;AAWE;EACE,iBAAA;AATJ;;AAaA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sCAAA;EACA,2DAAA;EACA,wEACE;EAEF,aAAA;EACA,4BAAA;AAZF;AAaE;EAEE,iDAAA;AAZJ;AAcE;EACE,WAAA;AAZJ;AAcE;EACE,+BAAA;AAZJ;AAcE;EACE,8BAAA;AAZJ;AAcE;EACE,+BAAA;AAZJ;AAcE;EACE,aAAA;EACA,WAAA;EACA,UAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAZJ;AAaI;EACE,oBAAA;EACA,mBAAA;AAXN;AAcM;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AAZR;AAeI;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAbN;AAgBE;EACE,aAAA;EACA,sBAAA;AAdJ;AAeI;EACE,aAAA;EACA,8BAAA;AAbN;AAgBU;EACE,0BAAA;AAdZ;AAkBM;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;AAhBR;AAiBQ;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,UAAA;EACA,yBAAA;AAfV;AAkBU;EACE,0BAAA;AAhBZ;AAoBU;EACE,8BAAA;AAlBZ;AAsBU;EACE,kEAAA;AApBZ;AAwBU;EACE,6BAAA;EACA,+BAAA;EACA,sBAAA;AAtBZ;AA0BU;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,2BAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,UAAA;AAxBZ;;AA+BA;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA5BF;AA6BE;EACE,iBAAA;AA3BJ","sourcesContent":[".Calendar:not(.Common) {\n  font-size: 0.92rem;\n  padding: 0.7rem 0.7rem 0 0.7rem;\n  background: white;\n  border: 1px solid var(--bs-primary);\n  border-radius: var(--bs-border-radius);\n  outline: none;\n\n  &.is-valid {\n    border-color: var(--bs-success);\n  }\n\n  &.is-invalid {\n    border-color: var(--bs-danger);\n  }\n\n  &.is-dirty {\n    border-color: var(--bs-warning);\n  }\n\n  div {\n    user-select: none;\n  }\n\n  .Calendar-Header {\n    padding: 0.2rem 1rem;\n\n    div {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n\n    div,\n    div input,\n    .sv-chevron-left,\n    .sv-chevron-right {\n      color: var(--bs-primary);\n    }\n\n    .sv-chevron-left,\n    .sv-chevron-right {\n      cursor: pointer;\n    }\n  }\n  .Calendar-Body {\n    padding: 0.5rem 0rem;\n\n    .Calendar-Date {\n      margin: 0 0.5rem 0.5rem 0.5rem;\n      cursor: pointer;\n\n      > .row {\n        color: var(--bs-gray-500);\n        align-items: center;\n      }\n\n      .row {\n        height: 2rem;\n      }\n\n      .day {\n        margin-top: 0.2rem;\n        height: 1.7rem;\n        width: 1.7rem;\n        border-radius: 0.25rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: var(--bs-primary);\n        line-height: 1rem;\n      }\n      .before {\n        color: #d8d1ca;\n      }\n      .today {\n        border: 1px solid rgba(0, 0, 0, 0.236);\n      }\n      .selected {\n        background: var(--bs-primary);\n        color: #fff;\n      }\n      .range-start {\n        background: green;\n        color: white;\n      }\n      .range-end {\n        background: green;\n        color: white;\n      }\n      .range {\n        background: rgba(0, 0, 0, 0.407);\n        color: white;\n      }\n    }\n  }\n}\n.popover .Calendar:not(.Common) {\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  .Calendar-Body {\n    padding-bottom: 0;\n  }\n}\n\n.Calendar-New {\n  position: relative;\n  display: flex;\n  padding: 0.5rem 1rem 0;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 1rem;\n  line-height: 2rem;\n  background-color: #fff;\n  border-radius: var(--bs-border-radius);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  transition:\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n  outline: none;\n  user-select: none !important;\n  &:focus,\n  &:focus-within {\n    box-shadow: 0 0 0 0.25rem rgba(27, 62, 111, 0.15);\n  }\n  > * {\n    width: 100%;\n  }\n  &.is-valid {\n    border-color: var(--bs-success);\n  }\n  &.is-invalid {\n    border-color: var(--bs-danger);\n  }\n  &.is-dirty {\n    border-color: var(--bs-warning);\n  }\n  .Calendar-Header {\n    display: flex;\n    width: 100%;\n    padding: 0;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.5rem;\n    .Calendar-Month {\n      padding: 0rem 0.5rem;\n      font-size: 0.875rem;\n    }\n    .Calendar-Year {\n      .Input {\n        width: 4rem;\n        text-align: center;\n        padding: 0.15rem;\n        border-color: var(--bs-border-color) !important;\n      }\n    }\n    .Calendar-Controls {\n      display: flex;\n      flex-grow: 1;\n      justify-content: end;\n      align-items: center;\n      gap: 1rem;\n    }\n  }\n  .Calendar-Body {\n    display: flex;\n    flex-direction: column;\n    .Calendar-Week {\n      display: flex;\n      justify-content: space-between;\n      &:first-of-type {\n        .Calendar-Day {\n          .Calendar-Date {\n            color: rgba(0, 0, 0, 0.25);\n          }\n        }\n      }\n      .Calendar-Day {\n        position: relative;\n        margin: 0;\n        text-align: center;\n        > .Calendar-Date {\n          position: relative;\n          display: inline-block;\n          width: 2rem;\n          height: 2rem;\n          margin: 0.15rem;\n          padding: 0.15rem 0.25rem;\n          z-index: 1;\n          text-transform: uppercase;\n        }\n        &.Calendar-Outset {\n          > .Calendar-Date {\n            color: rgba(0, 0, 0, 0.25);\n          }\n        }\n        &.Calendar-Range {\n          > .Calendar-Date {\n            background: var(--bs-gray-300);\n          }\n        }\n        &:not(.Calendar-Selected).Calendar-Today {\n          > .Calendar-Date {\n            border: var(--bs-border-width) solid var(--bs-gray-500) !important;\n          }\n        }\n        &.Calendar-Selected {\n          > .Calendar-Date {\n            background: var(--bs-primary);\n            border-color: var(--bs-primary);\n            color: var(--bs-white);\n          }\n        }\n        &.Calendar-Range + .Calendar-Range {\n          &:before {\n            content: '';\n            position: absolute;\n            width: 100%;\n            height: calc(100% - 0.3rem);\n            top: 0.15rem;\n            left: -50%;\n            background-color: var(--bs-gray-300);\n            z-index: 0;\n          }\n        }\n      }\n    }\n  }\n}\n.popover-body > .Calendar-New {\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  .Calendar-Body {\n    padding-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
